import { ImSpinner8 } from "react-icons/im";
import { EventItem } from "./events/EventItem";
import { EventListItem } from "~/types/EventTypes";
import React from "react";
import { DateTime } from "luxon";
import { getFormattedTimeStamp, groupAndSortByDate } from "~/utils/time";
import { cn } from "~/utils/fontsConfig";

const bgVariants = {
    black: "from-black to-black/0",
    card: "from-v3-card-gray to-v3-card-gray/0",
};

export const CalendarViewEventsList = ({
    queriedEvents,
    isLoadingEvents,
    variant = "black",
    order = "asc",
}: {
    queriedEvents: EventListItem[];
    isLoadingEvents: boolean;
    variant?: "black" | "card";
    order?: "asc" | "desc";
}) => {
    const eventsByDate = groupAndSortByDate(queriedEvents, order);

    if (queriedEvents.length === 0) {
        return (
            <div className="text-center text-v3-N-400">
                This user hasn't attended any events yet!
            </div>
        );
    }

    return (
        <>
            <div className="flex w-full flex-col">
                {isLoadingEvents ? (
                    <ImSpinner8 className="animate-spin" size={30} />
                ) : (
                    <>
                        {!queriedEvents.length && <div>No Events found</div>}

                        {eventsByDate.map(([date, events], index) => (
                            <div key={date}>
                                <div
                                    className={cn(
                                        bgVariants[variant],
                                        "sticky top-20 z-[110] w-full",
                                        `bg-gradient-to-b py-2`,
                                        "flex items-center gap-2",
                                    )}
                                >
                                    <span
                                        className={cn(
                                            "absolute left-[10px] w-[1px] bg-v3-N-450",
                                            index === 0
                                                ? "top-1/2 h-1/2"
                                                : "top-0 h-full",
                                        )}
                                    />
                                    <div
                                        className={cn(
                                            "z-[1] ml-[5px] h-[10px] w-[10px] rounded-full border-[1px] border-v3-N-400 bg-white",
                                            DateTime.fromMillis(date).diffNow(
                                                "days",
                                            ).days <= 0 && "bg-black",
                                        )}
                                    />
                                    <div className="w-max rounded-full bg-v3-N-500 px-3 py-2 text-[14px] shadow-[0_0_10px_rgba(0,0,0,0.9)]">
                                        {getFormattedTimeStamp(
                                            events[0]!.startTime,
                                            {
                                                showYear: false,
                                            },
                                        )}
                                    </div>
                                </div>
                                {events.map((event) => (
                                    <EventItem key={event.id} event={event} />
                                ))}
                            </div>
                        ))}
                    </>
                )}
            </div>
        </>
    );
};
